import { path } from "ramda";
import Colors from "../theme/Colors";
import { isAlive } from ".";
import Metrics from "../theme/Metrics";
export default {
	increaseBrightness(hex, percent){
		// strip the leading # if it's there
		hex = hex.replace(/^\s*#|\s*$/g, "");

		// convert 3 char codes --> 6, e.g. `E0F` --> `EE00FF`
		if(hex.length == 3){
			hex = hex.replace(/(.)/g, "$1$1");
		}

		var r = parseInt(hex.substr(0, 2), 16),
			g = parseInt(hex.substr(2, 2), 16),
			b = parseInt(hex.substr(4, 2), 16);

		return "#" +
        ((0|(1<<8) + r + (256 - r) * percent / 100).toString(16)).substr(1) +
        ((0|(1<<8) + g + (256 - g) * percent / 100).toString(16)).substr(1) +
        ((0|(1<<8) + b + (256 - b) * percent / 100).toString(16)).substr(1);
	},
	/**
     * Get main theme of type and calculate cycle ratio
     * {main, cycleRatio}
     * @param {object} theme 
     * @param {number} dataSize 
     */
	generateVisualizeThemeInfo(theme, vizKey, dataSize){
		const main = path(["data_visualize", vizKey, "main"], theme);
		const cycleRatio = Math.min(25, 100*main.length/dataSize);
		return {main, cycleRatio};
	},
	/**
     * Generate color array of visualize color.
     * @param {object} theme 
     * @param {string} vizKey 
     * @param {number} size 
     */
	generateVisualColorOfSize(theme, vizKey, size){
		const { main, cycleRatio } = this.generateVisualizeThemeInfo(theme, vizKey, size);
		const colors = [];
		for (let index = 0; index < size; index++) {
			const cycleIndex = Math.floor(index/main.length);
			colors.push(this.increaseBrightness(main[index % main.length], 
				cycleRatio * cycleIndex
			));
		}
		return colors;
	},
	/**
     * Get main theme color by adjust brightness of it's color,
     * using index of that color and how many data to display.
     * @param {object} theme 
     * @param {string} vizKey 
     * @param {number} colorIndex 
     * @param {number} totalDataLength 
     */
	getVisualizeColor(theme, vizKey, colorIndex, totalDataLength = 10){
		const acceptIndex = isAlive(colorIndex) ? colorIndex : 0;
		const { main, cycleRatio } = this.generateVisualizeThemeInfo(theme, vizKey, totalDataLength);
		const cycleIndex = Math.floor(acceptIndex/main.length);
		if(cycleIndex===0){
			return main[acceptIndex];
		}
		return this.increaseBrightness(main[acceptIndex % main.length], 
			cycleRatio * cycleIndex
		);
	},
	createHilightStyle(theme, visKey){
		const color = this.getVisualizeColor(theme, visKey, 0);
		return {
			border: `1px solid ${color}`,
			boxShadow: `0px ${Metrics.shadowDepth}px ${Metrics.shadowBlur}px 0 ${color}`
		};
	}
};


// WEBPACK FOOTER //
// ./src/util/ColorUtil.js